import config from '../../config'
import { HTTP } from  '../../http'
const pageSize = 15
export default {
    findAll: (keywords, page) => {
        return new Promise((resolve, reject) => {
            const model = {
                "searchOptions": {
                    "pageIndex": page,
                    "pageSize": pageSize,
                    "keywords": keywords
                }
            }
            HTTP.post(config.apiEndpoints.transactionStatusUri.concat('find'), model).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    find: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.transactionStatusUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    create: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.post(config.apiEndpoints.transactionStatusUri, {entity: model}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    update: (model) => {
        return new Promise((resolve, reject) => {
            HTTP.put(config.apiEndpoints.transactionStatusUri, {entity: model}).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    remove: (id) =>{
        return new Promise((resolve, reject) => {
            HTTP.delete(config.apiEndpoints.transactionStatusUri.concat(id)).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    },
    all: () => {
        return new Promise((resolve, reject) => {
            HTTP.get(config.apiEndpoints.transactionStatusUri).then((response)=>{
                resolve(response)
            }, (error)=>{
                reject(error)
            })
        })
    }
}